import { useEffect } from "react";

export default function InstagramPage() {
  useEffect(() => {
    window.location.replace("https://www.instagram.com/hynt_india/");
  }, []);

  return null;
}